/**
 * Odpre povezavo obvestila (`action_url`) — T3132.
 *
 * Večina obvestil vodi na pot znotraj aplikacije (`/projects/…`) in gre skozi
 * router. Storitveno obvestilo (T3132) in novica spletne strani (T2130) pa
 * vodita na spletno stran, torej na **absoluten** naslov na drugem gostitelju;
 * `navigate()` bi ga obravnaval kot relativno pot in pristal na 404. Tak
 * naslov odpremo v novem zavihku, aplikacija ostane odprta.
 */
const ABSOLUTE_URL = /^https?:\/\//i;

export function openActionUrl(url: string, navigate: (to: string) => void): void {
  if (ABSOLUTE_URL.test(url)) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  navigate(url);
}
